import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Lock } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const AdminCustomerTypes = () => {
  const [rows, setRows] = useState([]);
  const take = (d) => setRows(d.map((r) => ({ ...r, original: r.name })));
  useEffect(() => { api.get("/admin/customer-types").then((r) => take(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const set = (i, p) => setRows((r) => r.map((x, j) => (j === i ? { ...x, ...p } : x)));
  const del = (i) => {
    const r = rows[i];
    if (r.customers) return toast.error(`${r.customers} customer(s) use "${r.original}". Rename it instead.`);
    setRows((x) => x.filter((_, j) => j !== i));
  };
  const save = async () => {
    try { const { data } = await api.put("/admin/customer-types", rows.map(({ name, original }) => ({ name, original: original || "" }))); take(data); toast.success("Customer types saved. Customers see them in 'Who are you?'."); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-2xl space-y-4" data-testid="admin-customer-types">
      <p className="text-sm text-[#4A6358]">These are the choices customers see under "Who are you?". Add new ones such as Government, Factory or Industry. Renaming updates every customer of that type. A type can be deleted only when no customer uses it.</p>
      <div className="space-y-2">
        {rows.map((r, i) => (
          <div key={`${r.original || "new"}-${i}`} className="flex items-center gap-3 rounded-2xl border border-[#D2E0D8] bg-white p-3" data-testid={`ctype-row-${i}`}>
            <Input value={r.name} disabled={r.locked} onChange={(e) => set(i, { name: e.target.value })} placeholder="e.g. Government office" className="h-10 flex-1" data-testid={`ctype-name-input-${i}`} />
            <span className="w-24 text-xs text-[#6B7F74]" data-testid={`ctype-count-${i}`}>{r.customers || 0} {r.customers === 1 ? "customer" : "customers"}</span>
            {r.locked ? <Lock className="h-5 w-5 text-[#7B968B]" /> : <button onClick={() => del(i)} className="text-[#B4401F]" aria-label="delete" data-testid={`ctype-delete-${i}`}><Trash2 className="h-5 w-5" /></button>}
          </div>
        ))}
      </div>
      <div className="flex gap-3">
        <button onClick={() => setRows((r) => [...r, { name: "", original: "", customers: 0 }])} className="h-11 rounded-xl border-2 border-dashed border-[#2E9E6B] px-5 font-bold text-[#2E9E6B]" data-testid="ctype-add-btn">+ Add type</button>
        <button onClick={save} className="h-11 rounded-xl bg-[#0D3B2B] px-6 font-bold text-white" data-testid="ctype-save-btn">Save customer types</button>
      </div>
    </div>
  );
};
